import { useGetAccountQuery } from '@/services/accounts';
import { ReviewPackageActions } from '@/types/ReviewPackage';
import { Task } from '@/types/Tasks';
import { useParams } from 'react-router-dom';

import { ProgramType } from 'types';

import { InstallEnergyBackupMilestonePackage } from './InstallEnergyBackupMilestonePackage';
import { InstallGeneratorPackage } from './InstallGeneratorPackage';
import { InstallGeothermalPackage } from './InstallGeothermalPackage';
import { InstallHVACPackage } from './InstallHVACPackage';
import { InstallPackage } from './InstallPackage';
import { InstallWaterHeaterPackage } from './InstallWaterHeaterPackage';
import { LegacyMilestonePackage } from './LegacyMilestonePackage';

export const InstallMilestonePackageFactory = ({
  legacyReviewTasks,
  canSubmitInstallPackage,
}: {
  legacyReviewTasks: Task[];
  canSubmitInstallPackage: boolean;
}) => {
  const { id } = useParams<{ id: any; action: ReviewPackageActions }>();
  const { data: account } = useGetAccountQuery(id);

  if (legacyReviewTasks?.length) {
    return <LegacyMilestonePackage canSubmitInstallPackage={canSubmitInstallPackage} />;
  }

  switch (account?.programType) {
    case ProgramType.hvac:
      return <InstallHVACPackage canSubmitInstallPackage={canSubmitInstallPackage} />;
    case ProgramType.waterHeater:
      return <InstallWaterHeaterPackage canSubmitInstallPackage={canSubmitInstallPackage} />;
    case ProgramType.generator:
      return <InstallGeneratorPackage canSubmitInstallPackage={canSubmitInstallPackage} />;
    case ProgramType.geothermal:
      return <InstallGeothermalPackage canSubmitInstallPackage={canSubmitInstallPackage} />;
    case ProgramType.solar:
    case ProgramType.doePr:
    case ProgramType.newCommunity:
    case ProgramType.newHomes:
    case ProgramType.consumerSolar:
      return <InstallPackage canSubmitInstallPackage={canSubmitInstallPackage} />;
    case ProgramType.energyBackup:
      return <InstallEnergyBackupMilestonePackage canSubmitInstallPackage={canSubmitInstallPackage} />;
    default:
      return null;
  }
};
